// A refresh follows a committed write. Its failure must not invite a second write.
export const refreshAfterSave = async (refresh, warn) => {
  try {
    await refresh?.();
    return true;
  } catch {
    warn?.("Dữ liệu đã lưu nhưng chưa tải lại được. Hãy tải lại trang để kiểm tra; không gửi lại thao tác vừa lưu.", "warning");
    return false;
  }
};

// Keep successful requests when a later request fails; resume only unfinished work.
export const runPendingSteps = async (steps, completed) => {
  for (const { key, run } of steps) {
    if (completed.has(key)) continue;
    await run();
    completed.add(key);
  }
};
